import { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";
import { Equalizer } from "@/components/Equalizer";
import { jingleAudioUrl } from "@/lib/api";

export const MiniPlayer = ({ business, genre, src, stat, testId }) => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const el = audioRef.current;
    if (!el) return;
    if (playing) {
      el.pause();
    } else {
      document.querySelectorAll("audio").forEach((a) => a.pause());
      el.play();
    }
  };

  return (
    <div
      data-testid={testId}
      className="glass-panel rounded-2xl p-6 hover:border-gold/50 transition-colors group"
    >
      <audio
        ref={audioRef}
        src={src || jingleAudioUrl("demo")}
        preload="none"
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onEnded={() => setPlaying(false)}
      />
      <div className="flex items-center justify-between mb-5">
        <Equalizer playing={playing} color="#FF0055" />
        <button
          data-testid={`${testId}-play-btn`}
          onClick={toggle}
          className="h-12 w-12 rounded-full bg-gradient-to-br from-coral to-[#FF5000] flex items-center justify-center shadow-[0_0_20px_rgba(255,0,85,0.35)] hover:scale-110 active:scale-95 transition-transform cursor-pointer"
          aria-label={playing ? "Pause" : "Play"}
        >
          {playing ? <Pause className="h-5 w-5 text-white" /> : <Play className="h-5 w-5 text-white ml-0.5" />}
        </button>
      </div>
      <h3 className="font-display text-xl font-bold tracking-tight">{business}</h3>
      {genre && <p className="font-mono text-xs uppercase tracking-[0.2em] text-neon mt-1.5">{genre}</p>}
      {stat && <p className="text-sm text-slate-400 mt-3 leading-relaxed">{stat}</p>}
    </div>
  );
};
